export const T = {
  bg: '#09090B',
  surface: '#111115',
  surfaceUp: '#18181E',
  border: '#222228',
  accent: 'oklch(0.72 0.22 30)',
  accentSoft: 'oklch(0.72 0.22 30 / 0.1)',
  accentMid: 'oklch(0.72 0.22 30 / 0.2)',
  text: '#F0EEE9',
  textSec: '#85848F',
  textMuted: '#44444E',
  success: 'oklch(0.72 0.18 145)',
  warn: 'oklch(0.80 0.16 75)',
  error: 'oklch(0.68 0.2 25)',
} as const;
